import React from "react";
import dynamic from "next/dynamic";
const VendorBanner = dynamic(
  () => import("@/Components/pages/VendorRegistration/Banner")
);
const VendorFormStepperForm = dynamic(
  () => import("@/Components/pages/VendorRegistration/form")
);
const HocHead = dynamic(
  () => import("@/Components/HigherOrderComponent/HocHead"),
  { ssr: true }
);

const schema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@id": "https://www.trootech.com/#website",
      url: "https://www.trootech.com/",
      name: "AI Solutions, Enterprise Platforms, Data Engineering & Custom Software",
      "@type": "WebSite",
      inLanguage: "en-US",
      description:
        "Explore TRooTech’s AI solutions and enterprise platforms designed for growth, smarter workflows, and measurable business impact.",
      potentialAction: [
        {
          "@type": "SearchAction",
          target: {
            "@type": "EntryPoint",
            urlTemplate: "https://www.trootech.com/?s={search_term_string}",
          },
          "query-input": "required name=search_term_string",
        },
      ],
    },
    {
      "@id": "https://www.trootech.com/vendor-registration#webpage",
      url: "https://www.trootech.com/vendor-registration",
      name: "Vendor Registration | Partner with TRooTech Business Solutions",
      "@type": "WebPage",
      isPartOf: {
        "@id": "https://www.trootech.com/#website",
      },
      description:
        "Want to work with us? Fill out our vendor registration form to share your services and pricing. Let’s build a smooth, long-term partnership together.",
    },
  ],
};

const seo = {
  metaTitle: "Vendor Registration | Partner with TRooTech Business Solutions",
  metaDescription:
    "Want to work with us? Fill out our vendor registration form to share your services and pricing. Let’s build a smooth, long-term partnership together.",
  keywords:
    "Vendor Registration, TRooTech Business Solutions, Partner with TRooTech",
  canonicalURL: "https://www.trootech.com/vendor-registration",
  structuredData: schema,
};

const VendorRegistration: React.FC = () => {
  return (
    <div id="root">
      <HocHead seo={seo} />
      {/* Page Sections */}
      <VendorBanner />
      <VendorFormStepperForm />
    </div>
  );
};

export default VendorRegistration;
